import {Component, OnInit} from '@angular/core';
import {UserDataService} from '../../user-data.service';
import {UserInfoService} from '../../../../../user-info.service';

@Component({
    selector: 'app-main-account-details',
    templateUrl: './main-account-details.component.html',
    styleUrls: ['./main-account-details.component.scss']
})
export class MainAccountDetailsComponent implements OnInit {
    constructor(private userDataService: UserDataService,
                private userInfoService: UserInfoService) {}
    userData: any = [];
    userRole: string;
    company: any = [];
    infoLoaded: boolean;

    ngOnInit() {
        this.userDataService.autoLogin();

        this.userDataService.getMainData()
            .subscribe(user => {
                this.userRole = this.userDataService.userRole;
                this.infoLoaded = true;
            }, error => {
            });

        this.userDataService.getData()
            .subscribe(user => {
                this.userData = user;
            }, error => {
            });
        this.userDataService.getCurrentUserCompany()
            .subscribe(company => {
                this.company = company;
            }, error => {
            });
    }
}
